// This is a mixin which provides an object with the ability to manage persistent storage using localStorage
// Pass in obj to extend the obj's prototype with the methods.

export function MixinPersistentStore(obj, options={}) {
    mixinMethods(obj);
}

function mixinMethods(obj) {
    Object.assign(obj.__proto__, {

        /**
         * Set the persistent storage key to be used with the store.
         * @param {string} key is the key to use for the persistent storage.
         */
        setPersistentStorageKey(key) {
            this.persistentStorageKey = key;
        },

        /**
         * Set the persistent storage to a passed in LocalStorage instance.
         * @param {object} storage is a LocalStorage instance.
         */
        setPersistentStore(storage) {
            this.persistentStore = storage;
        },

        /**
         * Check if the persistent storage is set.
         * @returns {boolean} If there is a persistent storage object.
         */
        hasPersistentStorage() {
            return typeof this.persistentStore !== 'undefined' && this.persistentStore !== null;
        },

        /**
         * Our persistent storage is a JSON string that is stored in localStorage and is parsed into an object.
         * @returns {object} The persistent storage object.
         */
        getStore() {
            if (!this.hasPersistentStorage()) {
                console.warn('No persistent storage assigned', this);
                return {};
            }
            let store = this.persistentStore.getItem(this.persistentStorageKey);
            return ( typeof store === 'string' ? JSON.parse(store) : {} );
        },

        /**
         *
         * @param {object} obj is an object to persist into localStorage as a JSON string.
         */
        setStore(obj) {
            if (!this.hasPersistentStorage()) {
                console.warn('No persistent storage assigned', this);
                return;
            }
            obj = ( typeof obj === "object" ? obj : {} );
            this.persistentStore.setItem(this.persistentStorageKey, JSON.stringify(obj));
        },

        /**
         *
         * @param {string} key to access an item in the persistent storage.
         * @returns value for the passed in key from the persistent storage.
         */
        getStoreItem(key) {
            return this.getStore()[key];
        },

        /**
         *
         * @param {string} key to store the value against in the in persistent storage.
         * @param value
         */
        setStoreItem(key, value) {
            let store = this.getStore();
            store[key] = value;
            this.setStore(store);
        }


    });
}

// Check the state items that have been persisted and re-instate them into the state
export function initFromPersistentStore(stateMachine) {
    for (let key in stateMachine.persist) {
        let persistedValue = stateMachine.getStoreItem(key);
        if (typeof persistedValue !== 'undefined') {
            if (stateMachine.state[key] !== persistedValue) { stateMachine.commit(key, persistedValue) }
        }
    }
}
